import { Link } from "react-router-dom";
import { site } from "@/content";

/**
 * Футер. Один компонент на обе темы: цвета через dark:-варианты,
 * геометрия одинаковая.
 */
export default function LightFooter() {
  const footer = site.footer;

  return (
    <footer className="bg-white dark:bg-[#0A0A0A] border-t border-stone-200 dark:border-white/[0.06]">
      <div className="max-w-7xl mx-auto px-6 py-14">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16">
          <div className="flex-1 max-w-xs">
            <Link
              to="/"
              className="flex items-center gap-2.5 mb-4 cursor-pointer group"
            >
              <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-amber-600 dark:bg-amber-500 transition-all duration-300 group-hover:scale-110 group-hover:rotate-6 group-hover:bg-amber-500 dark:group-hover:bg-amber-400">
                <i
                  className={`${site.brand.icon} text-white dark:text-[#0A0A0A] text-sm transition-transform duration-300 group-hover:scale-110`}
                ></i>
              </div>
              <span className="font-extrabold text-lg tracking-tight text-stone-900 dark:text-white transition-colors duration-300 group-hover:text-amber-700 dark:group-hover:text-amber-300">
                {site.brand.name}
                <span className="text-amber-600 dark:text-amber-500 transition-colors duration-300 group-hover:text-amber-700 dark:group-hover:text-amber-300">
                  {site.brand.suffix}
                </span>
              </span>
            </Link>
            <p className="text-stone-600 dark:text-white/55 text-sm leading-relaxed mb-5">
              {footer.description}
              <br />
              {site.brand.legal}
            </p>
            <div className="flex gap-3">
              {site.socials.map((social) => (
                <a
                  key={social.key}
                  href={social.href}
                  aria-label={social.label}
                  className="w-9 h-9 flex items-center justify-center rounded-full bg-stone-100 dark:bg-white/[0.06] text-stone-600 dark:text-white/60 hover:bg-stone-900 dark:hover:bg-orange-500 hover:text-white dark:hover:text-[#0A0A0A] transition-all cursor-pointer"
                >
                  <i className={`${social.icon} text-sm`}></i>
                </a>
              ))}
            </div>
          </div>

          <div className="flex-1 grid grid-cols-2 sm:grid-cols-3 gap-8">
            {footer.columns.map((column) => (
              <div key={column.title}>
                <div className="text-stone-900 dark:text-white font-semibold text-sm mb-4">
                  {column.title}
                </div>
                <ul className="space-y-2.5">
                  {column.links.map((link) => (
                    <li key={link.text}>
                      <a
                        href={link.href}
                        className="text-stone-600 dark:text-white/55 text-sm hover:text-stone-900 dark:hover:text-white transition-colors cursor-pointer"
                      >
                        {link.text}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-stone-200 dark:border-white/[0.06] flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-stone-600 dark:text-white/55 text-xs">
            {footer.copyright}
          </p>
          <div className="flex gap-5">
            {footer.legalLinks.map((link) => (
              <a
                key={link.text}
                href={link.href}
                className="text-stone-600 dark:text-white/55 text-xs hover:text-stone-900 dark:hover:text-white cursor-pointer"
              >
                {link.text}
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}
